<div class="toro-widget-alert-banner-container">
    <div class="toro-widget-alert-banner-body">
        <div class="toro-widget-alert-banner-icon"><fa-icon icon="exclamation-triangle"></fa-icon></div>{{alertText}}
    </div>
    <div class="toro-widget-alert-banner-toolbar" (click)="onHideAlertBanner()">
        <fa-icon class="toro-widget-alert-toolbar-button" icon="times"></fa-icon>
    </div>
</div>
